import { queryOptions } from '@tanstack/react-query';
import type { GetUserData, GetUserResponse } from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

export const getMyUserKey = () => ['users', '@me'] as const;

const getMyUserUrl: GetUserData['url'] = 'users/@me';

export const getMyUserOptions = <T = GetUserResponse>() =>
  queryOptions<GetUserResponse, unknown, T>({
    queryKey: getMyUserKey(),
    queryFn: () => PrivateApi.get(getMyUserUrl).json<GetUserResponse>(),
  });
